import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { exportMerchantSupportThreads } from "./schema/agents/export-merchant-support-threads";
import { getChildThreads } from "./schema/agents/get-child-threads";
import { getIntercomConversationCount } from "./schema/agents/get-intercom-conversation-count";
import { getMerchantSupportThreads } from "./schema/agents/get-merchant-support-threads";
import { getThreadById } from "./schema/agents/get-thread-by-id";
import { getTriageV2Threads } from "./schema/agents/get-triage-v2-threads";

export const rpcDefinition = {
  getThreadById,
  getChildThreads,
  getMerchantSupportThreads,
  getTriageV2Threads,
  exportMerchantSupportThreads,
  getIntercomConversationCount,
};

export type AdminAgentsRpcDefinition = InferRpcDefinition<typeof rpcDefinition>;
